<template>
  <b-container class="pt-4 overflow-auto">
    <b-row class="dashboard-container pb-4">
      <b-col class="mb-4" cols="12" md="4">
        <div class="glass-effect">
          <div
            class="p-0"
            v-for="item in $store.state.safe_mode ? safe_menu : menu"
            :key="item.index"
          >
            <button
              class="py-3 px-4 w-100 text-left text-primary"
              :class="{ 'text-white': tabIndex !== item.index }"
              @click="tabIndex = item.index"
            >
              {{ $t(item.title) }}
            </button>
          </div>
          <div v-if="USER_ME.group_owner" class="p-0">
            <button
              class="py-3 px-4 w-100 text-left"
              :class="{ 'text-primary': tabIndex === 3 }"
              @click="tabIndex = 3"
            >
              {{ $t("group") }}
            </button>
          </div>
          <div class="py-3 px-4">
            <b-form-checkbox
              @change="(res) => $store.dispatch('toogleIsWhiteTheme', res)"
              :checked="$store.state.isWhiteTheme"
              size="lg"
              name="check-button"
              switch
            >
              <span class="text-white">
                {{ $t("white_theme") }}
              </span>
            </b-form-checkbox>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="8">
        <b-card class="h-100">
          <b-tabs no-key-nav v-model="tabIndex" nav-class="d-none">
            <b-tab>
              <p class="h3 mb-3">{{ $t("withdrawal") }}</p>

              <form ref="withdrawalForm" @submit.prevent="withdrawalRequest()">
                <b-row>
                  <b-col
                    class="mb-4 mx-auto d-flex flex-column"
                    cols="12"
                    lg="11"
                  >
                    <p>{{ $t("withdraw_funds") }}</p>

                    <b-input
                      name="amount"
                      class="mb-3"
                      :placeholder="$t('amount')"
                    ></b-input>
                    <p class="small">{{ $t("minimum_amount_withdraw") }}</p>
                    <b-input
                      name="wallet_address"
                      class="mb-3"
                      :placeholder="$t('wallet_address')"
                    ></b-input>
                    <p class="small">
                      {{ $t("withdrawal_wallet_alert") }}
                    </p>

                    <b-btn class="ml-auto" type="submit" variant="primary">
                      {{ $t("withdraw") }}
                    </b-btn>
                  </b-col>
                </b-row>
              </form>

              <div
                class="d-flex justify-content-center"
                v-if="withdrawals_loading"
              >
                <div class="d-flex">
                  <b-spinner class="mr-2" />
                  {{ $t("loading") }}
                </div>
              </div>

              <b-card
                v-else
                class="mb-3"
                v-for="withdrawal in MY_WITHDRAWALS"
                :key="withdrawal.id"
              >
                <p class="mb-0">
                  <img
                    class="mr-1"
                    width="20"
                    :src="require('@/assets/token-icon.svg')"
                    alt=""
                  />
                  {{ withdrawal.sum }}
                </p>

                <div class="mb-2 d-flex align-items-center">
                  <b-icon class="mr-2" icon="wallet"></b-icon>
                  <span
                    class="text-gray-300 d-flex align-items-center"
                    v-if="!withdrawal.show"
                  >
                    <span v-for="(i, index) in 10" :key="index">
                      <b-icon icon="dot"></b-icon>
                    </span>
                  </span>

                  <span v-else>{{ withdrawal.wallet_address }}</span>

                  <b-btn
                    class="ml-auto link-gray-100"
                    @click="toggleWalletVisible(withdrawal)"
                    size="sm"
                    variant="link"
                  >
                    <b-icon
                      :icon="withdrawal.show ? 'eye-slash' : 'eye'"
                    ></b-icon>
                  </b-btn>
                </div>

                <p class="mb-0 h6 text-gray-200 font-weight-light">
                  <span>
                    <b-icon class="mr-1" icon="clock" />
                    {{ dateConverter(withdrawal.request_date) }}
                  </span>

                  <span v-if="withdrawal.fulfilled_date !== null">
                    <b-icon class="mr-1" variant="success" icon="sucess" />
                    {{ dateConverter(withdrawal.fulfilled_date) }}
                  </span>
                </p>
              </b-card>
            </b-tab>

            <b-tab>
              <p class="h3 mb-3">{{ $t("payments") }}</p>

              <div
                class="d-flex justify-content-center"
                v-if="payments_loading"
              >
                <div class="d-flex">
                  <b-spinner class="mr-2" />
                  <p>{{ $t("loading") }}</p>
                </div>
              </div>

              <p
                v-else-if="MY_PAYMENTS.length < 1"
                class="mb-0 text-center"
                style="margin-top: 110px"
              >
                {{ $t("no_payments") }}
              </p>

              <b-card
                v-else
                class="mb-3"
                v-for="payment in MY_PAYMENTS"
                :key="payment.date"
              >
                <p class="mb-0">
                  <img
                    class="mr-1"
                    width="20"
                    :src="require('@/assets/token-icon.svg')"
                    alt=""
                  />
                  {{ payment.sum }}
                </p>
                <p class="mb-0 h6 text-gray-200 font-weight-light">
                  {{ dateConverter(payment.date) }}
                </p>
              </b-card>
            </b-tab>

            <b-tab>
              <p class="h3 mb-3">{{ $t("account") }}</p>

              <form
                ref="changeNicknameForm"
                class="mb-4 d-flex flex-column"
                @submit.prevent="changeNickName"
              >
                <p>{{ $t("change_nick") }}</p>

                <div class="d-flex">
                  <b-input
                    class="mr-3"
                    name="nick_name"
                    required
                    autocomplete="off"
                    v-model="new_nickname"
                    :placeholder="$t('username')"
                  />

                  <b-btn class="ml-auto" type="submit" variant="primary">
                    {{ $t("save") }}
                  </b-btn>
                </div>
              </form>

              <form
                ref="changePasswordForm"
                class="d-flex flex-column"
                @submit.prevent="changePassword"
              >
                <p>{{ $t("change_password") }}</p>
                <b-input
                  name="old_password"
                  required
                  autocomplete="off"
                  type="password"
                  class="mb-3"
                  :placeholder="$t('old_password')"
                ></b-input>
                <b-input
                  name="new_password"
                  required
                  autocomplete="off"
                  type="password"
                  class="mb-3"
                  :placeholder="$t('new_password')"
                ></b-input>
                <b-input
                  name="new_password_repeat"
                  required
                  autocomplete="off"
                  type="password"
                  class="mb-3"
                  :placeholder="$t('confirm_password')"
                ></b-input>
                <b-btn class="ml-auto" type="submit" variant="primary">
                  {{ $t("save") }}
                </b-btn>
              </form>
            </b-tab>

            <b-tab v-if="USER_ME.group_owner">
              <p class="h3 mb-3">{{ $t("group") }}</p>

              <b-card>
                <payments-from-group />
              </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "dashboard",

  data: () => ({
    tabIndex: 2,
    new_nickname: "",
    new_password: "",
    menu: [
      {
        title: "withdrawal",
        index: 0,
      },

      {
        title: "payments",
        index: 1,
      },

      {
        title: "account",
        index: 2,
      },
    ],

    safe_menu: [
      {
        title: "account",
        index: 2,
      },
    ],

    withdrawal_amount: "",
    withdrawal_wallet_adress: "",
    withdrawals_loading: false,
    withdrawals: [],

    payments_loading: false,

    new_password: "",
    new_password_repeat: "",
    old_password: "",
  }),

  computed: {
    ...mapGetters(["MY_PAYMENTS", "MY_WITHDRAWALS", "USER_ME"]),
  },

  methods: {
    ...mapActions([
      "get_my_payments",
      "get_my_withdrawals",
      "withdrawal_request",
    ]),

    toggleTheme(res) {
      console.log(res);
    },

    dateConverter(date) {
      return new Date(date).toUTCString();
    },

    toggleWalletVisible(e) {
      try {
        this.$set(e, "show", !e.show);
      } catch (err) {}
    },

    withdrawalRequest() {
      const formData = new FormData(this.$refs.withdrawalForm);

      const amount = formData.get("amount");

      if (!(amount < 100)) {
        this.$store.dispatch("withdrawal_request", formData).then(() => {
          this.$bvToast.toast("Your request succefuly send ;)", {
            variant: "success",
            title: "Yaapy",
          });
        });
      } else {
        this.$bvToast.toast("The minimum withdrawal amount is 100.", {
          variant: "danger",
          title: "Oops!",
        });
      }
    },

    changeNickName() {
      const formData = new FormData(this.$refs.changeNicknameForm);
      const nick_name = formData.get("nick_name");

      if (nick_name.length >= 5) {
        this.$store
          .dispatch("USERS_PUT_NICKNAME", formData)
          .then(() => {
            this.$store.dispatch("ME");
            this.$bvToast.toast("Nickname successfuly changed!", {
              variant: "success",
              autoHideDelay: 5000,
              title: "Success!",
            });
          })
          .catch(() => {
            this.$bvToast.toast(
              "The attempt to change the password has encountered an error.",
              {
                variant: "danger",
                autoHideDelay: 5000,
                title: "Nickname error!",
              }
            );
          });
      } else {
        this.$bvToast.toast(
          "The length of the nickname must be at least 5 characters.",
          {
            variant: "danger",
            autoHideDelay: 10000,
            title: "Nickname error!",
          }
        );
      }
    },

    changePassword() {
      const formData = new FormData(this.$refs.changePasswordForm);
      const new_password = formData.get("new_password");
      const new_password_repeat = formData.get("new_password_repeat");

      if (new_password === new_password_repeat) {
        const password_data = {
          old_password: this.old_password,
          new_password: this.new_password,
        };

        this.$store
          .dispatch("USERS_PUT_PASSWORD", formData)
          .then(() => {
            this.$refs.changePasswordForm.reset();
            this.$bvToast.toast("Password succesfuly changed!", {
              variant: "success",
              autoHideDelay: 5000,
              title: "Password success!",
            });
          })
          .catch((error) => {
            console.log(error);
            this.$bvToast.toast(
              error.response && error.response.status === 400
                ? error.response.data.detail
                : "The attempt to change the password has encountered an error.",
              {
                variant: "danger",
                autoHideDelay: 5000,
                title: "Password error!",
              }
            );
          });
      } else {
        this.$bvToast.toast("Password mismatch", {
          variant: "danger",
          autoHideDelay: 5000,
          title: "Password error!",
        });
      }
    },
  },

  mounted() {
    this.withdrawals_loading = true;
    this.payments_loading = true;
    this.get_my_payments().then(() => {
      this.payments_loading = false;
    });

    this.get_my_withdrawals().then((response) => {
      this.withdrawals_loading = false;
    });
    this.$store.dispatch("ME").then((res) => {
      this.new_nickname = this.new_nickname + res.data.nick_name;
    });
  },
};
</script>

<style scoped>
.dashboard-container {
  min-height: 100%;
}
</style>
